"use strict";

// Resize event listener
class ResizeClass {
	constructor() {
		// Store the window width
		this.windowWidth = window.innerWidth;
		this.nameFunctions = [];
		window.addEventListener("resize", this.runResize.bind(this), false);
	}
	runResize() {
		let nameFunctionsCopy = this.nameFunctions;
		clearTimeout(this.doit);
		this.doit = setTimeout(
			function() {
				if (window.innerWidth != this.windowWidth) {
					this.windowWidth = window.innerWidth;
					nameFunctionsCopy.forEach(itemFunction => {
						itemFunction();
					});
				}
			}
		, 100); // Timout change as needed
	}
	add(fData) {
		this.nameFunctions.push( fData );
	}
}

let windowResize = new ResizeClass();
// Use it by passing a function into it like so:
// windowResize.add( marketResize );

// Wrap last 2 letters in span
let productTitle = document.querySelector('.product-page__title');

if (productTitle) {
  let titleNum = productTitle.innerText.slice(-2);
  let titleName = productTitle.innerText.slice(0, -2);
  if (isNaN(titleNum)) {
  } else {
    productTitle.innerHTML = titleName + "<span>" + titleNum + "</span>";
  }
}

// Section Product Tabs
// const productTabs = document.querySelector('.product-tabs');
// if (productTabs) {
// 	const tabs = productTabs.querySelectorAll('[role="tabpanel"]');
// 	tabs.forEach(function(section) {
// 		let title = section.querySelector('h3');
// 		title.classList.add('mobile');
// 		title.addEventListener('click', function(e) {
// 			e.preventDefault();

// 		});
// 	});
// }

// function mobileTabPanel() {
// 	if (window.matchMedia("(min-width: 768px)").matches) {
// 		if(productTabs) {
// 			const tabs = productTabs.querySelectorAll('[role="tabpanel"]');
// 			tabs.forEach(function(section) {
// 				let title = section.querySelector('h3');
// 				title.classList.remove('mobile');
// 				title.classList.remove('active');
// 				title.removeEventListener('click', function(e) {
// 				});
// 			});
// 		}
// 	} else {
// 		console.log("Screen less than 500px")
// 		if(productTabs) {
// 			const tabs = productTabs.querySelectorAll('[role="tabpanel"]');
// 			tabs.forEach(function(section) {
// 				let title = section.querySelector('h3');

// 				if (!title.classList.contains('mobile')) {

// 					title.classList.add('mobile');
// 					title.addEventListener('click', function(e) {
// 						e.preventDefault();
// 						title.classList.toggle('active');
// 					});
// 				}
// 			});
// 		}
// 	}
// }
// mobileTabPanel();

// windowResize.add( mobileTabPanel );


/******************************************* custom.js below **************************************************/
	// Product Page images
		var galleryThumbs = new Swiper(".gallery-thumbs", {
			slidesPerView: 7,
			watchOverflow: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			direction: 'vertical',
			breakpoints: {
				1260: {
					slidesPerView: 5
				}
			  }
		});


		  var galleryMain = new Swiper(".gallery-main", {
			watchOverflow: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			preventInteractionOnTransition: true,
			effect: 'slide',
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev'
			},
			thumbs: {
			  swiper: galleryThumbs
			}
			});

var swiper1 = new Swiper('.home-hero-slideshow', {
  'onInit': function(){
    if ( Swiper.slides.length > 2 ) {
      this.loop = true
    }
  },
// Optional parameters
direction: 'horizontal',
slidesPerView: 1,
watchOverflow: true,
  loop: false,
//effect: 'createive',
// loop: true,
lazy: true,
autoHeight: true, //enable auto height
	autoplay: {
		delay: 8000,
		disableOnInteraction: true,
	},


// Navigation arrows

});

// Product Description move into tabs

const descriptionContents = document.querySelector('.product-single__description');

if (descriptionContents) {

	const tabsParent = document.querySelector('.product-tabs__tabs');
	const tabs = document.querySelector('.tabs');

	let tabsBuild;
	const dCArray = descriptionContents.innerHTML.split('<h2>');
	let counter = 1;
	let firstSelected = false;
	dCArray.forEach(function(item) {
		if (item.includes('</h2>')) {
			let itemArray = item.split('</h2>');
			let itemTitle = itemArray[0];
            itemTitle = itemTitle.replace("<br>", "");
            itemTitle = itemTitle.replace("&nbsp;", "");
			let itemContent = itemArray[1];

			let itemTitleLower = itemTitle.toLowerCase();

			if (itemTitleLower != "sidebar" && itemTitleLower != "product manual") {


			// Create button Tab
			let button = document.createElement('button');
			button.id = "tab-" + counter;
			button.type = "button";
			// button.role = "tab";
			button.setAttribute("role", "tab");
			button.setAttribute("aria-controls", "tabpanel-" + counter);

			let span = document.createElement('span');
			span.class = "focus";
			span.innerText = itemTitle;


			// Create content
			let div = document.createElement('div');
			let h3 = document.createElement('h3');
			div.id = "tabpanel-" + counter;
			// div.role="tabpanel";
			div.setAttribute("role", "tabpanel");
			div.tabIndex = "0";
			div.setAttribute("aria-labelledby", "tab-" + counter);
			h3.innerText = itemTitle;

			div.innerHTML = itemContent;
			div.prepend(h3);

			div.classList = "product-tabs__content-panel";
			// if (firstSelected == false) {
				// button.ariaSelected = "true";
				div.classList += " is-hidden";
				// firstSelected = true;
			// } else {
				button.ariaSelected = "false";
			// }
			button.append(span);
			tabsParent.append(button);
			tabs.append(div);

			} else {
				let sidebarContent = document.querySelector('.product-tabs__more-info-content');
				let h4 = document.createElement('h4');
				let div = document.createElement('div');
				h4.innerText = "More Information";
				div.innerHTML = itemContent;


				sidebarContent.append(h4);
				sidebarContent.append(div);
			}

			counter++;
		}
	});
}

/******************************************* END custom.js **************************************************/


/***************************************** THE MATT EDITS BEGIN BELOW THIS LINE ****************************************************/

const productJson = document.querySelectorAll('[id^=ProductJson-');

//let color = document.querySelector('#SingleOptionSelector-0');
//let size  = document.querySelector('#SingleOptionSelector-1');

let color = false;
let size  = false;
let colorSelector = '';
let sizeSelector = '';

if( document.querySelectorAll('#SingleOptionSelector-0 .product-swatches__color-selector').length > 0 ) {
  color = document.querySelector('#SingleOptionSelector-0');
  colorSelector = 'SingleOptionSelector-0';
}
if( document.querySelectorAll('#SingleOptionSelector-1 .product-swatches__color-selector').length > 0 ) {
  color = document.querySelector('#SingleOptionSelector-1');
  colorSelector = 'SingleOptionSelector-1';
}

if( document.querySelectorAll('#SingleOptionSelector-0 .product-swatches__btn-selector').length > 0 ) {
  size = document.querySelector('#SingleOptionSelector-0');
  sizeSelector = 'SingleOptionSelector-0';
}
if( document.querySelectorAll('#SingleOptionSelector-1 .product-swatches__btn-selector').length > 0 ) {
  size = document.querySelector('#SingleOptionSelector-1');
  sizeSelector = 'SingleOptionSelector-1';
}



if (color) {
	let colorSelected = '';
	let colorInputs = color.getElementsByTagName('input');
	for( let i = 0; i < colorInputs.length; i++ ) {
        colorInputs[i].disabled = ''; // overriding shopify, always have options enabled <-----------
        
		if( colorInputs[i].checked ) {
			colorSelected = colorInputs[i].value;
		}
	}
	color.addEventListener('change', function(){

		for( let i = 0; i < colorInputs.length; i++ ) {

			if( colorInputs[i].checked ) {
              
				colorSelected = colorInputs[i].value;
                if( colorSelected.length > 0 ) {
                  let fs = document.getElementById(colorSelector);
                  let elem = fs.firstChild;
                  do {
                      if (elem.tagName != 'LEGEND') continue;
                      if( elem.tagName == 'LEGEND') {
                        elem.innerHTML = "<strong>Color: </strong>" + colorSelected;
                      }
                  } while (elem = elem.nextSibling)
                }
                updatePrice();

                let elem = colorInputs[i].parentNode.firstChild;
                do {
                    if (elem.tagName != 'LABEL') continue;
                    if( elem.tagName == 'LABEL') {
                      let img = elem.getElementsByTagName('img');
                      let vyeslideimgs = document.querySelectorAll('.vyeslideimg');
                      vyeslideimgs.forEach(function(vyeslideimg) {
                            if( /\/\/.*\?/.exec(vyeslideimg.getAttribute('src') )[0] == /\/\/.*\?/.exec(img[0].getAttribute('src'))[0] ) {
                              if(vyeslideimg.dataset.imageindex && 0 < vyeslideimg.dataset.imageindex ) {
                                //console.log( 'current index ' + galleryMain.activeIndex );
                                let slidetoindex = (vyeslideimg.dataset.imageindex - 1);
                                // console.log( 'slidetoindex ' + slidetoindex );
                                galleryMain.slideTo(slidetoindex);
                                // console.log( 'index after slide ' + galleryMain.activeIndex );
                              }
                            }
                    	});
                    }
                } while (elem = elem.nextSibling)
               }
            }
        });
  color.dispatchEvent(new Event("change"));
}

if (size) {
    let sizeSelected = '';
	let sizeInputs = size.getElementsByTagName('input');
	for( let i = 0; i < sizeInputs.length; i++ ) {
      sizeInputs[i].disabled = ''; // overriding shopify, always have options enabled <-----------
      if( sizeInputs[i].checked ) {
          sizeSelected = sizeInputs[i].value;
      }
	}
	size.addEventListener('change', function(){
    for( let i = 0; i < sizeInputs.length; i++ ) {
        if( sizeInputs[i].checked ) {
            sizeSelected = sizeInputs[i].value;
            if( sizeSelected.length > 0 ) {
              let fs = document.getElementById(sizeSelector);
              let elem = fs.firstChild;
              do {
                  if (elem.tagName != 'LEGEND') continue;
                  if( elem.tagName == 'LEGEND') {
                    elem.innerHTML = "<strong>Size: </strong>" + sizeSelected;
                  }
              } while (elem = elem.nextSibling)
            }
           }
        }
      updatePrice();
    });
  size.dispatchEvent(new Event("change"));
}


function updatePrice(){
  let color = document.querySelector('#SingleOptionSelector-0');
  let colorSelected = '';
  if (color) {
      let colorInputs = color.getElementsByTagName('input');
      for( let i = 0; i < colorInputs.length; i++ ) {
          if( colorInputs[i].checked ) {
              colorSelected = colorInputs[i].value;
          }
      }
  }

  let size = document.querySelector('#SingleOptionSelector-1');
  let sizeSelected = '';
  if (size) {
    let sizeInputs = size.getElementsByTagName('input');
      for( let i = 0; i < sizeInputs.length; i++ ) {
        if( sizeInputs[i].checked ) {
            sizeSelected = sizeInputs[i].value;
        }
      }
  }



  if( colorSelected.length || sizeSelected.length ) {
    if (productJson.length > 0) {

      document.querySelector( '.price__sale').style.display = 'none';
      let price = document.querySelector( '.price__regular .price-item--regular');
      price.innerText = 'Not Available';
      price.style.textDecoration = 'none';
      document.querySelector( '.price__regular').style.display = 'block';

      let submit_btn = document.querySelector( '.product-form__cart-submit' );
      let submit_btn_span = submit_btn.querySelector('[data-add-to-cart-text]');
      submit_btn.disabled = "disabled";
      submit_btn.classList.remove('btn--blue');
      submit_btn_span.innerHTML = "Sold Out";

      productJson.forEach((product) => {
        const productObject = JSON.parse(product.innerHTML);
        productObject.variants.forEach((variant) => {
          if( variant.available ) {
            if( colorSelected == variant.option1 && sizeSelected == variant.option2 ) {
              submit_btn.disabled = "";
              submit_btn.classList.add('btn--blue');
              submit_btn_span.innerHTML = "Add To Cart";
              if( null != variant.compare_at_price){
                let price = document.querySelector( '.price__regular .price-item--regular');
                price.innerText = '$'+(variant.compare_at_price / 100).toFixed(2);
                price.style.textDecoration = 'line-through';
                document.querySelector( '.price__regular').style.display = 'block';

                let saleprice = document.querySelector( '.price__sale .price-item--sale');
                saleprice.innerText = '$'+(variant.price / 100).toFixed(2);
                document.querySelector( '.price__sale').style.display = 'block';
              } else if( null != variant.price ) {
                document.querySelector( '.price__sale').style.display = 'none';
                let price = document.querySelector( '.price__regular .price-item--regular');
                price.innerText = '$'+(variant.price / 100).toFixed(2);
                price.style.textDecoration = 'none';
                document.querySelector( '.price__regular').style.display = 'block';
              }
            } else if( colorSelected == variant.option1 && sizeSelected.length == 0 ) {
              submit_btn.disabled = "";
              submit_btn.classList.add('btn--blue');
              submit_btn_span.innerHTML = "Add To Cart";
              if( null != variant.compare_at_price){
                let price = document.querySelector( '.price__regular .price-item--regular');
                price.innerText = '$'+(variant.compare_at_price / 100).toFixed(2);
                price.style.textDecoration = 'line-through';
                document.querySelector( '.price__regular').style.display = 'block';

                let saleprice = document.querySelector( '.price__sale .price-item--sale');
                saleprice.innerText = '$'+(variant.price / 100).toFixed(2);
                document.querySelector( '.price__sale').style.display = 'block';
              } else if( null != variant.price ) {
                document.querySelector( '.price__sale').style.display = 'none';
                let price = document.querySelector( '.price__regular .price-item--regular');
                price.innerText = '$'+(variant.price / 100).toFixed(2);
                price.style.textDecoration = 'none';
                document.querySelector( '.price__regular').style.display = 'block';
              }
              var newurl =
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname +
                '?variant=' +
                variant.id;
              window.history.replaceState({ path: newurl }, '', newurl);
              // shopify thing. sets variant id into field for submit
              //if( document.getElementById('ProductSelect-product-template') ) {
              if( document.querySelector('[id^="ProductSelect"]') ) {
                //document.getElementById('ProductSelect-product-template').value = variant.id;  
                document.querySelector('[id^="ProductSelect"]').value = variant.id;  
              }
            }
          }
          if( colorSelected == variant.option1 && sizeSelected == variant.option2 ) {
            var newurl =
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname +
                '?variant=' +
                variant.id;
              window.history.replaceState({ path: newurl }, '', newurl);
            
              // shopify thing. sets variant id into field for submit
              //if( document.getElementById('ProductSelect-product-template') ) {
              if( document.querySelector('[id^="ProductSelect"]') ) {
                //document.getElementById('ProductSelect-product-template').value = variant.id;  
                document.querySelector('[id^="ProductSelect"]').value = variant.id;  
              }
              
          }
        });
      });
    }
  }













}



/***************************************** END MATT EDITS  ****************************************************/